import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import styles from './CustomInjectionBlock.module.scss';

function CustomInjectionBlock({ className = null, children = null, ...props }) {
  return (
    <div id={props.id} className={classNames(styles.Block, className)}>
      {children}
    </div>
  );
}

CustomInjectionBlock.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default CustomInjectionBlock;
